import React, { useState } from "react";
import { Text, Platform, StyleSheet, View } from "react-native";

import Device from "./Device";
import AppTheme from "../../../AppTheme";
import AccountMenuOptions from "../../common/AccountMenuOptions";
import { INTEGRATION_KEYS } from "../../IntegrationsHelper";
import SourceReceivedData from "../SourceReceivedData";
import IntegrationFabButton from "../IntegrationFabButton";

export default function DevicesList({
  controller,
  devices,
  showDownloadLinks = () => {},
  toggleDeviceStatus = () => {},
  disconnectAccount = () => {},
  editDevice = () => {},
}) {
  const [selectedDevice, setSelectedDevice] = useState(null);
  const integrationsRef = React.createRef();

  return (
    <>
      <View style={{ flex: 1 }}>
        <Text style={styles.headerText}>Devices connected</Text>

        {devices.map((device, index) => (
          <Device
            controller={controller}
            key={index}
            device={device}
            toggleDeviceStatus={toggleDeviceStatus}
            onLongPress={() => setSelectedDevice(device)}
            onPress={() => editDevice(device)}
          />
        ))}

        <Text style={styles.linkText} onPress={() => showDownloadLinks(true)}>
          Get Mana for new desktop
        </Text>

        {/* All data */}
        <SourceReceivedData
          ref={integrationsRef}
          sourceName={INTEGRATION_KEYS.desktop}
          controller={controller}
          isExpandable={false}
        />
      </View>

      <IntegrationFabButton
        getManaforDesktop={() => showDownloadLinks(true)}
        refresh={() => {
          controller.getItems();
          integrationsRef.current.loadData();
        }}
      />

      <AccountMenuOptions
        controller={controller}
        account={selectedDevice}
        accounts={devices}
        close={() => setSelectedDevice(null)}
        disconnectAccount={disconnectAccount}
        integrationName={INTEGRATION_KEYS.desktop}
      />
    </>
  );
}

const styles = StyleSheet.create({
  headerText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: "#8B92A1",
    marginBottom: 4,
    paddingLeft: 6,
  },
  linkText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.DEFAULT_COLOR,
    width: "100%",
    textAlign: "center",
    marginTop: 20,
    marginBottom: 20,
  },
});
